import { abs } from '@/lib/mediaUrl';

const hashStr = (s = '') => {
    let h = 0;
    for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
    return h;
};

// Branded, deterministic placeholder so a story without a cover still reads
// as an on-brand tile (never a blank square).
export const BrandedCover = ({ title = '', tag, showTitle = true, className = '' }) => {
    const h = hashStr(title || 'story');
    const angle = h % 360;
    const bx = 15 + (h % 55);
    const by = 10 + ((h >> 3) % 45);

    return (
        <div
            data-testid="story-cover-generated"
            className={`relative w-full h-full overflow-hidden bg-[#0B0B0C] ${className}`}
        >
            <div
                className="absolute inset-0"
                style={{
                    background: `linear-gradient(${angle}deg, color-mix(in oklab, var(--accent) 12%, #0B0B0C), #0B0B0C 62%)`,
                }}
            />
            <div
                className="absolute rounded-full blur-3xl opacity-40"
                style={{
                    width: '55%',
                    height: '55%',
                    left: `${bx}%`,
                    top: `${by}%`,
                    background:
                        'radial-gradient(circle, var(--accent), transparent 70%)',
                }}
            />
            <div
                className="absolute inset-0 opacity-[0.16]"
                style={{
                    backgroundImage:
                        'radial-gradient(circle, rgba(255,255,255,0.65) 1px, transparent 1px)',
                    backgroundSize: '18px 18px',
                }}
            />
            <div className="absolute inset-0 p-5 md:p-6 flex flex-col justify-between">
                <div className="font-mono-brand text-[9.5px] uppercase tracking-[0.28em] text-white/55">
                    Zeerow · Story
                </div>
                <div>
                    {tag && (
                        <span className="mb-2 inline-block rounded-full border border-white/20 bg-white/5 px-2 py-0.5 font-mono-brand text-[9px] uppercase tracking-[0.2em] text-[var(--accent)]">
                            {tag}
                        </span>
                    )}
                    {showTitle && (
                        <div className="font-display leading-[1.05] text-white text-[clamp(1.1rem,2.4vw,1.9rem)] line-clamp-3">
                            {title || 'Untitled story'}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

// Renders the real cover when present, otherwise the branded placeholder.
export const StoryCover = ({ post = {}, imgClassName = '' }) => {
    if (post.cover_url) {
        return (
            <img
                src={abs(post.cover_url)}
                alt={post.title || ''}
                loading="lazy"
                className={imgClassName || 'w-full h-full object-cover'}
            />
        );
    }
    return <BrandedCover title={post.title} tag={(post.tags || [])[0]} />;
};

export default StoryCover;
